import { ClientEvent } from '@udemy/event-tracking';
import { idFromGlobalId } from '@udemy/graphql';
import { SubscriptionPlanProductType } from '@udemy/subscription-graphql';
class SubscriptionCancelEvent extends ClientEvent {
  constructor(subscriptionPlanEnrollmentId) {
    super('SubscriptionCancelEvent');
    this.subscriptionPlanEnrollmentId = void 0;
    this.subscriptionPlanEnrollmentId = subscriptionPlanEnrollmentId;
  }
}
class SubscriptionReactivateEvent extends ClientEvent {
  constructor(subscriptionPlanEnrollmentId) {
    super('SubscriptionReactivateEvent');
    this.planId = void 0;
    this.planId = subscriptionPlanEnrollmentId;
  }
}
class SubscriptionAvailablePlanPurchaseInitiateEvent extends ClientEvent {
  constructor(planId) {
    super('SubscriptionAvailablePlanPurchaseInitiateEvent');
    this.planId = void 0;
    this.planId = planId;
  }
}
function getIdFromGlobalId(planId) {
  const intPlanId = parseInt(planId, 10);
  return isNaN(intPlanId) ? idFromGlobalId(planId) : intPlanId;
}

/** The expected SubscriptionPlan data for a SubsciptionOfferPresented event */

/**
 * Event fired when a user sees a subscription offer for a personal plan
 */
class SubscriptionOfferPresented extends ClientEvent {
  constructor({
    subscriptionPlan,
    productType,
    countryCode,
    courseId = null,
    courseTrackingId = null,
    badges = null,
    uiRegion
  }) {
    super('SubscriptionOfferPresented');
    this.primaryPricingOption = void 0;
    this.allPricingOptions = void 0;
    this.productType = void 0;
    this.countryCode = void 0;
    this.courseId = void 0;
    this.courseTrackingId = void 0;
    this.badges = void 0;
    this.uiRegion = void 0;
    const pricingOptions = this.formatPricingOptions(subscriptionPlan);
    this.primaryPricingOption = pricingOptions[0];
    this.allPricingOptions = pricingOptions;
    this.productType = this.mapProductType(productType);
    this.countryCode = countryCode;
    this.courseId = courseId;
    this.courseTrackingId = courseTrackingId;
    this.badges = badges;
    this.uiRegion = uiRegion;
  }
  mapProductType(planProductType) {
    switch (planProductType) {
      case SubscriptionPlanProductType.Team:
        return 'team';
      case SubscriptionPlanProductType.GrowWithGoogle:
        return 'grow_with_google';
      case SubscriptionPlanProductType.ConsumersubscriptionPlusGrowWithGoogle:
        return 'consumer_subscription_plus_grow_with_google';
      default:
        return 'consumer';
    }
  }
  formatPricingOptions(subscriptionPlan) {
    return subscriptionPlan.priceOptions.map(option => {
      var _option$trial, _option$trial$dateInt, _option$trial2;
      return {
        price: option.listPrice.amount,
        listPrice: option.listPrice.amount,
        currency: option.listPrice.currency,
        renewalIntervalType: option.renewalInterval.type.toLowerCase(),
        renewalIntervalCount: option.renewalInterval.count,
        hasTrial: !!((_option$trial = option.trial) !== null && _option$trial !== void 0 && _option$trial.dateInterval),
        trialDays: (_option$trial$dateInt = (_option$trial2 = option.trial) === null || _option$trial2 === void 0 || (_option$trial2 = _option$trial2.dateInterval) === null || _option$trial2 === void 0 ? void 0 : _option$trial2.count) !== null && _option$trial$dateInt !== void 0 ? _option$trial$dateInt : null
      };
    });
  }
}
class SubscriptionOfferImpressionEvent extends ClientEvent {
  constructor(planId, courseId = null, uiRegion, courseTrackingId, hasTrial = null, trialDays = null, badges = null, planPriceIds = null, noticeId = null, bundleId = null, bundleType = null) {
    super('SubscriptionOfferImpressionEvent');
    this.planPriceId = void 0;
    this.courseId = void 0;
    this.uiRegion = void 0;
    this.courseTrackingId = void 0;
    this.hasTrial = void 0;
    this.trialDays = void 0;
    this.badges = void 0;
    this.planPriceIds = void 0;
    this.noticeId = void 0;
    this.bundleId = void 0;
    this.bundleType = void 0;
    this.planPriceId = getIdFromGlobalId(planId).toString();
    this.courseId = courseId;
    this.uiRegion = uiRegion;
    this.courseTrackingId = courseTrackingId;
    this.hasTrial = hasTrial;
    this.trialDays = trialDays;
    this.badges = badges;
    this.planPriceIds = planPriceIds === null || planPriceIds === void 0 ? void 0 : planPriceIds.map(planPriceId => getIdFromGlobalId(planPriceId));
    this.noticeId = noticeId;
    this.bundleId = bundleId;
    this.bundleType = bundleType;
  }
}
class SubscriptionCTAClickEvent extends ClientEvent {
  constructor(planId, planType, ctaType, uiRegion, courseId = null, courseTrackingId, planPriceIds = null, noticeId = null, bundleId = null, bundleType = null) {
    super('SubscriptionCTAClickEvent');
    this.planPriceId = void 0;
    this.planType = void 0;
    this.ctaType = void 0;
    this.uiRegion = void 0;
    this.courseId = void 0;
    this.courseTrackingId = void 0;
    this.planPriceIds = void 0;
    this.noticeId = void 0;
    this.bundleId = void 0;
    this.bundleType = void 0;
    this.planPriceId = parseGlobalIdOrPlanPriceId(planId).toString();
    this.planType = planType;
    this.ctaType = ctaType;
    this.uiRegion = uiRegion;
    this.courseId = courseId;
    this.courseTrackingId = courseTrackingId;
    this.planPriceIds = planPriceIds === null || planPriceIds === void 0 ? void 0 : planPriceIds.map(planPriceId => getIdFromGlobalId(planPriceId));
    this.noticeId = noticeId;
    this.bundleId = bundleId;
    this.bundleType = bundleType;
  }
}
class SubscriptionLearnMoreEvent extends ClientEvent {
  constructor(planId, planType, uiRegion, planPriceIds = null, noticeId = null) {
    super('SubscriptionLearnMoreEvent');
    this.planPriceId = void 0;
    this.planType = void 0;
    this.uiRegion = void 0;
    this.planPriceIds = void 0;
    this.noticeId = void 0;
    this.planPriceId = parseGlobalIdOrPlanPriceId(planId).toString();
    this.planType = planType;
    this.uiRegion = uiRegion;
    this.planPriceIds = planPriceIds === null || planPriceIds === void 0 ? void 0 : planPriceIds.map(planPriceId => getIdFromGlobalId(planPriceId));
    this.noticeId = noticeId;
  }
}
class SubscriptionSurveyClickEvent extends ClientEvent {
  constructor(planId, status, url, uiRegion) {
    super('SubscriptionSurveyClickEvent');
    this.planPriceId = void 0;
    this.status = void 0;
    this.url = void 0;
    this.uiRegion = void 0;
    this.planPriceId = planId;
    this.status = status;
    this.url = url;
    this.uiRegion = uiRegion;
  }
}
const parseGlobalIdOrPlanPriceId = id => {
  try {
    return getIdFromGlobalId(id); // For the new store the id is will be an integer 74
  } catch {
    return parseInt(id, 10);
  }
};
class SubscriptionPlanSelectEvent extends ClientEvent {
  constructor(planId, hasTrial, trialDays, badges = null, nonInteraction = false, planPriceIds = null) {
    super('SubscriptionPlanSelectEvent');
    this.planPriceId = void 0;
    this.hasTrial = void 0;
    this.trialDays = void 0;
    this.badges = void 0;
    this.nonInteraction = void 0;
    this.planPriceIds = void 0;
    this.planPriceId = parseGlobalIdOrPlanPriceId(planId);
    this.hasTrial = hasTrial;
    this.trialDays = trialDays;
    this.badges = badges;
    this.nonInteraction = nonInteraction;
    this.planPriceIds = planPriceIds === null || planPriceIds === void 0 ? void 0 : planPriceIds.map(planPriceId => parseGlobalIdOrPlanPriceId(planPriceId));
  }
}
class SubscriptionStartClickEvent extends ClientEvent {
  constructor(planId, hasTrial, trialDays, planPriceIds = null) {
    super('SubscriptionStartClickEvent');
    this.planPriceId = void 0;
    this.hasTrial = void 0;
    this.trialDays = void 0;
    this.planPriceIds = void 0;
    this.planPriceId = parseGlobalIdOrPlanPriceId(planId);
    this.hasTrial = hasTrial;
    this.trialDays = trialDays;
    this.planPriceIds = planPriceIds === null || planPriceIds === void 0 ? void 0 : planPriceIds.map(planPriceId => getIdFromGlobalId(planPriceId));
  }
}
class SubscriptionStartErrorEvent extends ClientEvent {
  constructor(planId, errorMessage) {
    super('SubscriptionStartErrorEvent');
    this.planPriceId = void 0;
    this.errorMessage = void 0;
    this.planPriceId = parseGlobalIdOrPlanPriceId(planId);
    this.errorMessage = errorMessage;
  }
}
export { getIdFromGlobalId };
export { SubscriptionOfferPresented, SubscriptionCancelEvent, SubscriptionReactivateEvent, SubscriptionAvailablePlanPurchaseInitiateEvent, SubscriptionOfferImpressionEvent, SubscriptionCTAClickEvent, SubscriptionLearnMoreEvent, SubscriptionSurveyClickEvent, SubscriptionPlanSelectEvent, SubscriptionStartClickEvent, SubscriptionStartErrorEvent };
//# sourceMappingURL=subscription-events.js.map